import React, { useEffect, useState, useRef } from 'react';
import { useParams } from "react-router-dom";
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import ReactMarkdown from 'react-markdown';

const Travelcarousel = (props) => {
    const { postId } = useParams();
    const [page, setPage] = useState([]);
    const [elements, setElements] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const intervalRef = useRef(null);
    const [producteurs, setProducteurs] = useState([]);
    const [isAutoPlay, setIsAutoPlay] = useState(true);
    const [currentIndexP, setCurrentIndexP] = useState(0);
    const intervalRefP = useRef(null);
    const [isAutoPlayP, setIsAutoPlayP] = useState(true);
   
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    let pageNum = 0;
    typeof (postId) === "undefined" ? pageNum = 1 : pageNum = postId;

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/travel/${pageNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res.length > 0) {
                    setPage(res[0]);
                } else {
                    fetch(`${URL_COURTJUS_BACK}/travelcarousel`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(res => {
                            setPage(res[0]);
                        });
                }
            });
    }, []);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/travelelements/${pageNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setElements(res);
            });
    }, []);

    useEffect(() => {
        // Nettoyer l'interval existant d'abord
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        // Créer un nouvel interval seulement si autoplay est activé
        if (elements.length > 0 && isAutoPlay) {
            intervalRef.current = setInterval(() => {
                setCurrentIndex(prev => (prev + 1) % elements.length);
            }, 7000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [elements.length, isAutoPlay]);

    // Fonction pour toggler l'autoplay
    const toggleAutoPlay = () => {
        setIsAutoPlay(prev => !prev);
    };

    const showSlide = (index) => {
        if (index < 0) {
            setCurrentIndex(elements.length - 1);
        } else if (index >= elements.length) {
            setCurrentIndex(0);
        } else {
            setCurrentIndex(index);
        }
    };

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/producteurs`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setProducteurs(res);
            });
    }, []);
    
        // Auto-défilement
    useEffect(() => {
        // Nettoyer l'interval existant d'abord
        if (intervalRefP.current) {
            clearInterval(intervalRefP.current);
            intervalRefP.current = null;
        }

        // Créer un nouvel interval seulement si autoplay est activé
        if (producteurs.length > 0 && isAutoPlayP) {
            intervalRefP.current = setInterval(() => {
                setCurrentIndexP(prev => (prev + 1) % producteurs.length);
            }, 6000);
        }

        return () => {
            if (intervalRefP.current) {
                clearInterval(intervalRefP.current);
            }
        };
    }, [producteurs.length, isAutoPlayP]);

    // Fonction pour toggler l'autoplay
    const toggleAutoPlayP = () => {
        setIsAutoPlayP(prev => !prev);
    };

    const showSlideP = (index) => {
        if (index < 0) {
            setCurrentIndexP(producteurs.length - 1);
        } else if (index >= producteurs.length) {
            setCurrentIndexP(0);
        } else {
            setCurrentIndexP(index);
        }
    };

    return (
        <main className="container">
            <link rel="stylesheet" href="/css/stylescarousel.css"/>
            <div className="main-down"></div>

            <section className="section-travel">
                <div className="carousel">
                    <div 
                        className="carousel-slides"
                        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                        {elements.map((q, i) =>
                            <div 
                                className={i === currentIndex ? "carousel-slide active" : "carousel-slide"} 
                                key={i}
                            >
                                <h4>{q.eTitre}</h4>
                                <div className="slide-content">
                                    <img src={`/img/pictures/${q.ePhoto}`} alt={`Article ${page.pageNum} paragraphe ${i}`} />
                                    <div className="slide-text">
                                        <ReactMarkdown>{q.eText.replace(/\n/g, '  \n')}</ReactMarkdown>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <button 
                        className="carousel-btn prev carousel-btn-l" 
                        aria-label="Précédent"
                        onClick={() => showSlide(currentIndex - 1)}
                    >
                        &#10094;
                    </button>
                    <button 
                        className="carousel-btn next carousel-btn-r" 
                        aria-label="Suivant"
                        onClick={() => showSlide(currentIndex + 1)}
                    >
                        &#10095;
                    </button>
                    <button 
                        onClick={toggleAutoPlay}
                        className="autoplay-toggle"
                        aria-label={isAutoPlay ? "Mettre en pause" : "Reprendre"}
                        title={isAutoPlay ? "Arreter le defilement automatique " : "reprendre le defilement automatique "}
                    >
                        {isAutoPlay ? "Pause ⏸" : "Play ▶"}
                    </button>

                    <div className="carousel-indicators">
                        {elements.map((q, i) =>
                            <span 
                                key={i} 
                                className={i === currentIndex ? "active" : ""}
                                onClick={() => showSlide(i)}
                            ></span>
                        )}
                    </div>
                </div>
            </section>
            <section className="section-travel">
                <div className="carousel">
                    <div 
                        className="carousel-slides"
                        style={{ transform: `translateX(-${currentIndexP * 100}%)` }}
                    >
                        {producteurs.map((q, i) =>
                            <div 
                                className={i === currentIndexP ? "carousel-slide active" : "carousel-slide"} 
                                key={i}
                            >
                                <h4>{q.uStructure}</h4>
                                <div className="slide-content">
                                    <img src={`/img/pictures/${q.uPhotoProfil}`} alt={`Producteur ${q.uPrenom} ${q.uNom}  (${q.uMail})`} />
                                    <div className="slide-text">
                                        <h3 title={`${q.uPrenom} ${q.uNom}`}>{q.uPrenom} {q.uNom}</h3>
                                        {/* <p>{q.uMailPro && q.uMailPro}{q.uMailPro === "" && q.uMail}</p> */}
                                        <p className="p-impact">  {q.uProduction}</p>
                                        <p><hr /></p>
                                        {/* <p>{q.uTel}</p>
                                        <p>{q.uAdr_CP} {q.uAdr_Ville}</p> */}
                                        <ReactMarkdown>
                                            {q.uInfosComp && q.uInfosComp.length > 5
                                                ? (q.uInfosComp.length > 1000 
                                                    ? q.uInfosComp.substring(0, 1000).trim().split(' ').slice(0, -1).join(' ') + '...' 
                                                    : q.uInfosComp)
                                                : 'Au cœur des montagnes alpines, des producteurs passionnés perpétuent des savoir-faire et façonnent un terroir d exception.'
                                            }
                                        </ReactMarkdown>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <button 
                        className="carousel-btn prev carousel-btn-l" 
                        aria-label="Précédent"
                        onClick={() => showSlideP(currentIndexP - 1)}
                    >
                        &#10094;
                    </button>
                    <button 
                        className="carousel-btn next carousel-btn-r" 
                        aria-label="Suivant"
                        onClick={() => showSlideP(currentIndexP + 1)}
                    >
                        &#10095;
                    </button>
                    <button 
                        onClick={toggleAutoPlayP}
                        className="autoplay-toggle"
                        aria-label={isAutoPlayP ? "Mettre en pause" : "Reprendre"}
                        title={isAutoPlayP ? "Arreter le defilement automatique " : "reprendre le defilement automatique "}
                    >
                        {isAutoPlayP ? "Pause ⏸" : "Play ▶"}
                    </button>

                    <div className="carousel-indicators">
                        {producteurs.map((q, i) =>
                            <span 
                                key={i} 
                                className={i === currentIndexP ? "active" : ""}
                                onClick={() => showSlideP(i)}
                            ></span>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Travelcarousel;